import axios from 'axios';

export const API_URL = process.env.REACT_APP_MASTER_API_URL || (process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:5199/api');

export const createApi = (token) => {
  const instance = axios.create({
    baseURL: API_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
  });
  if (token) instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  return instance;
};

export const getToken = () => localStorage.getItem('masterToken');
export const setToken = (token) => localStorage.setItem('masterToken', token);
export const clearToken = () => localStorage.removeItem('masterToken');
